import * as React from 'react';
import { Abbr } from 'components';

/**
 * Konfiguracja Intl.NumberFormat do formatowania liczb
 */
export const SMALLNUMBER = Intl.NumberFormat('pl-PL', {
  maximumFractionDigits: 4,
});

export const NUMBER = Intl.NumberFormat('pl-PL', {
  maximumFractionDigits: 2,
});

export const LARGENUMBER = Intl.NumberFormat('pl-PL', {
  maximumFractionDigits: 0,
});

export function getPercentageIncrease(numA: number, numB: number): number {
  const percentage = ((numA - numB) / numB) * 100;
  return percentage;
}

export function formatValue(
  value: string | number | undefined,
): string | JSX.Element {
  if (typeof value === 'undefined' || !value) return '0';
  if (typeof value === 'number' || typeof value === 'bigint') {
    if (value >= 1000) return LARGENUMBER.format(value);
    if (value >= 1) return NUMBER.format(value);
    if (value >= 0.01) return SMALLNUMBER.format(value);
    if (value > 0) return <Abbr text='&lt; 0.01' tooltip={value} />;
    return '0';
  }

  return value;
}

export const fomratNumberSpace = (value: number | string): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const formatCurrency = (
  value: number,
  locale = 'pl-PL',
  fractionDigits = 2,
): string => {
  return Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
};
